import { render, staticRenderFns } from "./ForgotCard.vue?vue&type=template&id=b0697438&scoped=true&"
import script from "./ForgotCard.vue?vue&type=script&lang=js&"
export * from "./ForgotCard.vue?vue&type=script&lang=js&"
import style0 from "./ForgotCard.vue?vue&type=style&index=0&id=b0697438&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0697438",
  null
  
)

export default component.exports